export enum InsurersEnum {
  Allianz = 'allianz',
  Aviva = 'aviva',
  Axa = 'axa',
  AxaAssistance = 'axa_assistance',
  Balcia = 'balcia',
  Beesafe = 'beesafe',
  Benefia = 'benefia',
  Colonnade = 'colonnade',
  Compensa = 'compensa',
  DallBogg = 'dallbogg',
  Direct = 'direct',
  Ergo = 'ergo',
  ErgoHestia = 'ergohestia',
  Euroins = 'euroins',
  Gefion = 'gefion',
  Generali = 'generali',
  Gothaer = 'gothaer',
  Hestia = 'hestia',
  InterRisk = 'interrisk',
  Irys = 'irys',
  Link4 = 'link4',
  Mtu = 'mtu',
  Mtu24 = 'mtu24',
  Ominimo = 'ominimo',
  Pevno = 'pevno',
  Proama = 'proama',
  Pzu = 'pzu',
  Redclick = 'redclick',
  SignalIduna = 'signaliduna',
  Trasti = 'trasti',
  Tuz = 'tuz',
  Uniqa = 'uniqa',
  UniqaAssistance = 'uniqa_assistance',
  Wefox = 'wefox',
  Wiener = 'wiener',
  YouCanDrive = 'ycd',
}
